import React, { FormEvent, useState } from "react";
import Button from "../../Button/Button";
import Modal from "../Modal";
import { AddressElement } from "@stripe/react-stripe-js";
import { IBillingResponse } from "../../../types/types";
import { UpdateBillingDetails } from "../../../services/billingDetails.service";
import useAuthService from "../../../auth/AuthService";

const BillingAddress: React.FC<{
  isVisible?: boolean;
  data: IBillingResponse;
  onClick?: () => void;
  onClose?: () => void;
}> = ({ isVisible, data, onClick, onClose }) => {
  const { getToken } = useAuthService();
  const [state, setState] = useState({
    isLoading: false,
    error: "",
    billingDetails: {
      name: data?.name,
      phone: data?.phone,

      address_line1: data?.address_line1,
      address_line2: data?.address_line2,
      city: data?.city,
      state: data?.state,
      postal_code: data?.postal_code,
      country: data?.country,
    },
  });

  const handleBillingDetails = async (event: FormEvent) => {
    event.preventDefault();

    let error: string = "";
    const { phone, postal_code } = state.billingDetails;

    console.log("Phone:", phone, "Postal Code:", postal_code);

    // Validate postal code
    if (!postal_code || !/^\d{5,6}$/.test(postal_code)) {
      error = "Please Provide Correct details";
    }

    // Validate phone number **only if user enters something**
   

    if (error !== "") {
      // Set error state
      setState((prev) => ({
        ...prev,
        error: error, // Remove extra spaces if no errors
      }));
      return;
    }

    try {
      setState((prev) => ({ ...prev, isLoading: true }));
      const response = await UpdateBillingDetails(
        getToken,
        state.billingDetails
      );
      if (response.error) {
        setState((prev) => ({ ...prev, error: response.error as string }));
      } else {
        onClick && onClick();
      }
    } catch (err) {
      setState((prev) => ({ ...prev, error: err as string }));
    } finally {
      setState((prev) => ({ ...prev, isLoading: false }));
    }
  };

  const modalBody = (
    <>
      <div className="modal-body bg-modalbody m-3 pt-0 mt-0">
        <form
          className="account-form text-start"
          onSubmit={handleBillingDetails}
        >
          <div className="row mb-3">
            <div className="col mb-3 address-element">
              <AddressElement
                options={{
                  mode: "billing",
                  display: { name: "full" },
                  fields: {
                    phone: "never",
                  },
                  defaultValues: {
                    name: data?.name,
                    phone: data?.phone,
                    address: {
                      line1: data?.address_line1,
                      line2: data?.address_line2,
                      city: data?.city,
                      state: data?.state,
                      country: data?.country,
                      postal_code: data?.postal_code,
                    },
                  },
                }}
                onChange={(event) => {
                  if (event.complete || event.isNewAddress) {
                    // Extract potentially complete address
                    const stripeAddress: any = event.value;
                    setState((prev) => ({
                      ...prev,
                      error:"",
                      billingDetails: {
                        ...prev.billingDetails,
                        name: stripeAddress.name,
                        address: stripeAddress.address,
                        phone: stripeAddress.phone,
                        address_line1: stripeAddress.address.line1,
                        address_line2: stripeAddress.address.line2,
                        city: stripeAddress.address.city,
                        state: stripeAddress.address.state,
                        postal_code: stripeAddress.address.postal_code,
                        country: stripeAddress.address.country,
                      },
                    }));
                  }
                }}
              />
            </div>
          </div>

          {state.error && <p style={{ color: "red" }}>{state.error}</p>}

          <div className="mb-1 mt-3 d-flex justify-content-center">
            <Button
              label={state.isLoading ? "Processing..." : "Save Address"}
              type="submit"
              variant="primary"
              className="w-100 font-18 font-500"
              disabled={state.isLoading}
            />
          </div>
        </form>
      </div>
    </>
  );

  return (
    <Modal
      id="billingAddressModal"
      title="Billing Address"
      body={modalBody}
      modalBackground={"modal-bg"}
      onClose={onClose}
      isVisible={isVisible}
    />
  );
};

export default BillingAddress;
